import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormPorscheEventComponent } from './form-porsche-event.component';

import { FormsModule } from '@angular/forms';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { ReactiveFormsModule } from '@angular/forms';
const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [FormPorscheEventComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    RouterModule
  ],
  exports: [FormPorscheEventComponent]
})
export class FormPorscheEventModule { }
